<template>
  <div> TEST ADMİN
  </div>
</template>

<script>
export default { 
}
</script>

<style scoped> 
</style>
